<template>
  <div>
    <page-title v-if="!loading">{{ currentSurvey.current_version.title }}</page-title>
    <loading v-if="loading" />
    <section-block class="c-container" v-else header-hidden>
      <template slot="header"> </template>
      <div
        v-if="
          currentSurvey.private && (currentSurvey.created_user.id !== userId && !userInvited)
        "
      >
        <h1>Survey is private</h1>

        <p>You are not able to view this survey</p>
      </div>
      <form-builder-form :form="currentSurvey" type="survey" v-else />
    </section-block>
  </div>
</template>

<script>
import FormBuilderForm from "@/components/FormBuilderForm";
import { mapState } from "vuex";

export default {
  methods: {
    getBaseResp(elems) {
      let respObj = {};
      elems.elements.forEach((elem) => {
        respObj[elem.properties.label] = "";
      });
      return respObj;
    },
  },
  data() {
    return {
      submitted: false,
      loading: true,
    };
  },
  async created() {
    // this.$router;
    const formUrl = `/${this.$route.params.pathMatch}`;

    await this.$store.dispatch("Surveys/retrieveByUrl", formUrl);
    this.loading = false;
  },
  components: {
    FormBuilderForm,
  },
  computed: {
    ...mapState("Surveys", ["currentSurvey"]),
		userInvited() {
      if (!this.currentSurvey.users) {
        return false;
      }
      const users = this.currentSurvey.users.filter(
        user => user.id == this.$store.state.auth.currentUser.id
      );

      return users && users.length;
    },
		userId() {
      if (!this.$store.state.auth.currentUser.id) {
        this.$store.dispatch("auth/listCurrentUser").then(resp => {
          return this.$store.state.auth.currentUser.id;
        });
      } else {
        return this.$store.state.auth.currentUser.id;
      }
    },
  },
};
</script>
